import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("table", () => {
    it("should render the table component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-table></ux-table>`);
        const tableComponent = await page.find("ux-table");
        expect(tableComponent).toHaveClass("hydrated");
    });

    it("it has a link in the first column", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <ux-table sortable>
          <table>
            <thead>
                <tr>
                    <th scope="row">
                        <ux-table-sort>Favorite</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Number</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Name</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Year</ux-table-sort>
                    </th>
                    <th scope="row">Link</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td data-sort="1">
                        1
                    </td>
                    <td>3</td>
                    <td>TruLaser</td>
                    <td>2019</td>
                    <td><a href="#" class="ux-button">Details</a></td>
                </tr>
            </tbody>
          </table>
        </ux-table>
      `);
        await page.waitForChanges();
        const linksInFirstCell = await page.findAll(`tbody > *:first-child a`);
        expect(linksInFirstCell.length).toBe(1);
    });

    it("it sorts numerical values correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-table sortable>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <ux-table-sort
                                    class="sorter-1"
                                    numerical
                                >
                                    Favorite
                                </ux-table-sort>
                            </th>
                            <th>
                                <ux-table-sort
                                    class="sorter-2"
                                    numerical
                                >
                                    Number
                                </ux-table-sort>
                            </th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-sort="1">Test 1</td>
                            <td><ux-number-format value="45.98"></ux-number-format></td>
                        </tr>
                        <tr>
                            <td data-sort="0">Test 2</td>
                            <td><ux-number-format value="180.67"></ux-number-format></td>
                        </tr>
                        <tr>
                            <td data-sort="1">Test 3</td>
                            <td><ux-number-format value="849"></ux-number-format></td>
                        </tr>
                        <tr>
                            <td data-sort="2">Test 4</td>
                            <td><ux-number-format value="9.01"></ux-number-format></td>
                        </tr>
                    </tbody>
                </table>
            </ux-table>
        `);
        await page.waitForChanges();
        const dataAttributeTableSort = await page.find(".sorter-1");
        const textTableSort = await page.find(".sorter-2");
        let firstCell = await page.find("td");
        let secondCell = await page.find("td:nth-of-type(2)");
        expect(firstCell.textContent).toBe("Test 1");
        await dataAttributeTableSort.click();
        await page.waitForChanges();
        firstCell = await page.find("td");
        expect(firstCell.textContent).toBe("Test 2");
        await dataAttributeTableSort.click();
        await page.waitForChanges();
        firstCell = await page.find("td");
        expect(firstCell.textContent).toBe("Test 4");
        expect(secondCell.textContent).toBe("45.98");
        await textTableSort.click();
        await page.waitForChanges();
        secondCell = await page.find("td:nth-of-type(2)");
        expect(secondCell.textContent).toBe("9.01");
        await textTableSort.click();
        await page.waitForChanges();
        secondCell = await page.find("td:nth-of-type(2)");
        expect(secondCell.textContent).toBe("849");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-table sortable>
          <table>
            <thead>
                <tr>
                    <th scope="row">
                        <ux-table-sort>Favorite</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Number</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Name</ux-table-sort>
                    </th>
                    <th scope="row">
                        <ux-table-sort>Year</ux-table-sort>
                    </th>
                    <th scope="row">Link</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td data-sort="1">
                        1
                    </td>
                    <td>3</td>
                    <td>TruLaser</td>
                    <td>2019</td>
                    <td><a href="#" class="ux-button">Details</a></td>
                </tr>
            </tbody>
          </table>
        </ux-table>`);
    });
});
